// extracted by mini-css-extract-plugin
module.exports = {"root":"root--wLerC","icon":"icon--Jjdf7"};